/**
 * Card #3408 — the TS runtime's house vendor name, in ONE place: what a surface built on this design
 * system shows when the tenant sets no `branding.vendor_name` (or before `/me` / the form's theme has
 * answered). The engine's own copy is C# `TenantBranding.HouseVendorShortName`; this mirrors it for
 * the browser apps that render the shared rail and the form footer, so an unbranded tenant renders
 * byte-identically to before the branding block existed. A surface never spells the name itself: it
 * passes the tenant's vendor name, falling back to this.
 *
 * (The client portal keeps its own house strings in `apps/client-portal/src/theme/vendorCopy.ts`, #3410 Out.)
 */
export const HOUSE_VENDOR_NAME = "AR Dept";
/** The tenant's vendor name when it names one (non-blank after trimming), else {@link HOUSE_VENDOR_NAME}. */
export function vendorNameOrHouse(vendorName) {
    const name = vendorName?.trim();
    return name ? name : HOUSE_VENDOR_NAME;
}
//# sourceMappingURL=houseVendor.js.map